export default "__VITE_ASSET__CFK976QR__"